import Send from "../communication"
import { buildQueryParams, getPeriodDate } from "../utils/dateUtils"
import { getIds } from "../utils/getIds"

const paramsStartPage = (projectIds, startPageFilters, scopeType) => {

  const isFalsyProjectId = (val) =>
    val === null ||
    val === undefined ||
    val === '' ||
    val === 'null' ||
    val === 'undefined'

  const normalizeSingleQuotes = (str) => {
    if (!str) return ''

    const cleaned = str.replace(/^'+|'+$/g, '')
    return `${cleaned}`
  }

  const [startDate, endDate] = getPeriodDate(startPageFilters?.period);
  const dateParams = startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : ``;
  const technicianIds = startPageFilters?.technician?.length > 0 ? `&tecId=${getIds(startPageFilters?.technician)}` : ``
  const searchTerm = !isFalsyProjectId(startPageFilters?.search) ? `&producerName=${normalizeSingleQuotes(startPageFilters?.search)}` : ``
  const projectQueryIds = isFalsyProjectId(projectIds) ? `scopeType=${scopeType}` : `projects='${projectIds}'`

  return { dateParams, technicianIds, searchTerm, projectQueryIds }
}

export const getAssistancesByTec = async (
  user,
  projectIds,
  scopeType,
  technicianSelect,
  currentUserRole,
  projectsPeriodFilter,
) => {
  const queryParams = buildQueryParams(
    user,
    projectIds,
    scopeType,
    technicianSelect,
    currentUserRole,
    projectsPeriodFilter,
  )

  const response = await Send.get(`/nps/assistancesByTec`, queryParams)
  return response
}

export const getAppointmentsData = async (
  user,
  scope,
  scopeType,
  startPageFilters,
  projectIds,
  projects,
  currentUserRole,
) => {

  let response = null

  const { projectQueryIds, technicianIds, dateParams, searchTerm } = paramsStartPage(projectIds, startPageFilters, scopeType)

  const query = `/events-sector/responsible`

  if (currentUserRole === 'USER_MANAGER' || currentUserRole === 'USER_ADMIN') {
    const finalQuery = `${projectQueryIds}${technicianIds}${dateParams}${searchTerm}`;
    response = await Send.get(query, finalQuery)
  }

  if (currentUserRole === 'USER_TEC') {
    const finalQuery = `${projectQueryIds}&tecId='${user.id}'${dateParams}${searchTerm}`;
    response = await Send.get(query, finalQuery)
  }


  if (!response?.data) return []

  return response.data.map((item) => {
    return {
      ...item
    }
  })
}

export const getAssistanceData = async (user,
  scope,
  scopeType,
  startPageFilters,
  projectIds,
  projects,
  currentUserRole,
) => {

  let response = null

  const { projectQueryIds, technicianIds, dateParams, searchTerm } = paramsStartPage(projectIds, startPageFilters, scopeType)

  const query = `/nps/assistancesByTec`

  if (currentUserRole === 'USER_MANAGER' || currentUserRole === 'USER_ADMIN') {
    const finalQuery = `${projectQueryIds}${technicianIds}${dateParams}${searchTerm}`;
    response = await Send.get(query, finalQuery)
  }

  if (currentUserRole === 'USER_TEC') {
    const finalQuery = `${projectQueryIds}&tecId='${user.id}'&${dateParams}${searchTerm}`;
    response = await Send.get(query, finalQuery)
  }

  try {

    if (response) {

      const openedData = response?.open?.length > 0
        ? response.open?.sort((a, b) => new Date(a.dateToAdd) - new Date(b.dateToAdd))
        : []

      const finishedData = response?.finished?.length > 0
        ? response.finished?.sort((a, b) => new Date(b.dateToAdd) - new Date(a.dateToAdd))
        : []

      return { openedData, finishedData }
    }
  } catch (error) {
    console.log(error)
  }
}

